import {
  PC_SIMULATION_START,
  PC_SIMULATION_END,
  PC_SIMULATION_RESULT,
} from '../../actions/ContractCompilance/PriceComplianceSimulation.ActionTypes';

const initialState = {
  loading: false,
  simulationResult: {},
};

const PriceComplianceSimulationReducer = (state = initialState, action) => {
  switch (action.type) {
    case PC_SIMULATION_START:
      return { ...state, loading: true };
    case PC_SIMULATION_END:
      return { ...state, loading: false };
    case PC_SIMULATION_RESULT:
      return { ...state, simulationResult: action.data };
    default:
      return state;
  }
};

export default PriceComplianceSimulationReducer;
